module.exports = __webpack_public_path__ + "assets/img/offie-logo-black.66d5c1ff.svg";